/* Copyright (c) 2024 VMware, Inc. All rights reserved. VMware Confidential */
export * from "./app-config.service";
